module.exports = __webpack_public_path__ + "static/media/detailedSubtractFootball.5c35bc6a.svg";